/**
 * 首页
 * Created by Yata on 2017/9/21 0001.
 */

export default [{
        path: '/volume/:saleWay',
        component: () => import('../components/homePage/volumeList.vue'),
    },
    {
        path: '/volume/:saleWay/:id',
        component: () => import('../components/homePage/offerDetailed.vue'),
    },
    {
        path: '/coupon/explain',
        name: '优惠券帮助',
        component: () => import('../components/homePage/explain.vue'),
    },
    {
        path: '/home',
        component: () => import('../components/homePage/LIVING.vue'),
        meta: {
            title: "乐生活"
        },
    },
    {
        path: '/home/:list/',
        component: () => import('../components/homePage/pastList.vue'),
    },
    {
        path: '/home/:list/:id',
        component: () => import('../components/homePage/hierarchDetails2.vue'),
    },
    {
      path: '/home2/:list/:id',
      component: () => import('../components/homePage/hierarchDetails2.vue'),
    },
    {
      path: '/home2/:list/:id',
      component: () => import('../components/homePage/hierarchDetails2.vue'),
  },
    {
        path: '/recomendation/:id',
        component: () => import('../components/homePage/recommendationDetails.vue'),
    },
    {
        path: '/home/:list/:id/all',
        name: 'all',
        component: () => import('../components/homePage/more.vue'),
        meta: {
            title: "更多精选评论"
        },
    }
]
